/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * The caller's own ``linkedin.com/in/`` URL; null forgets it.
 */
export interface SetLinkedinRequest {
  url?: string | null;
}
